module.exports = __webpack_public_path__ + "img/search-icon.b0bfcb33.svg";